import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OptimizelyFlags } from '../../../types/type';

interface ApiState {
  data: OptimizelyFlags | null;
}

const initialState: ApiState = {
  data: null,
};

const optimizelyFlagSlice = createSlice({
  name: 'optimizelyFeatureFlags',
  initialState,
  reducers: {
    updateFeatureFlags(state, action: PayloadAction<{ OptimizelyResponse: OptimizelyFlags }>) {
      state.data = action.payload.OptimizelyResponse;
    },
  },
});

export const { updateFeatureFlags } = optimizelyFlagSlice.actions;
export default optimizelyFlagSlice.reducer;
